import { gql } from "generated-graphql";

export const STAFF_CERS_CUPA_CONFLICTS = gql(`
  query StaffCersCupaConflicts($search: String, $page: Int, $pageSize: Int) {
    staffCersCupaConflicts(search: $search, page: $page, pageSize: $pageSize) {
      count
      items {
        cersFacility {
          cersId
          name
          cupaCode
        }
        facility {
          id
          name
          tenantId
          streetAddress1
          city
          state
          zip
          county
          tenant {
            id
            name
          }
        }
        cersCupa {
          id
          cupaCode
          displayName
        }
        encampLepc {
          id
          name
        }
        encampCupa {
          id
          cupaCode
          displayName
        }
      }
    }
  }
`);

export const RESOLVE_CERS_CUPA_CONFLICT = gql(`
  mutation ResolveCersCupaConflict($cersFacilityId: ID!, $resolution: CersCupaConflictResolution!, $note: String, $expectedEncampLepcId: ID) {
    resolveCersCupaConflict(cersFacilityId: $cersFacilityId, resolution: $resolution, note: $note, expectedEncampLepcId: $expectedEncampLepcId) {
      cersId
    }
  }
`);

export const STAFF_CERS_CUPA_CONFLICT_RESOLUTIONS = gql(`
  query StaffCersCupaConflictResolutions($search: String, $page: Int, $pageSize: Int) {
    staffCersCupaConflictResolutions(search: $search, page: $page, pageSize: $pageSize) {
      count
      items {
        id
        resolution
        note
        resolvedAt
        isUndoable
        undoneAt
        resolvedBy {
          id
          email
        }
        undoneBy {
          id
          email
        }
        cersFacility {
          cersId
        }
        facility {
          id
          name
          tenantId
          streetAddress1
          city
          state
          zip
          tenant {
            id
            name
          }
        }
        cersLepc {
          id
          name
        }
        previousLepc {
          id
          name
        }
      }
    }
  }
`);

export const UNDO_CERS_CUPA_CONFLICT_RESOLUTION = gql(`
  mutation UndoCersCupaConflictResolution($resolutionId: ID!) {
    undoCersCupaConflictResolution(resolutionId: $resolutionId) {
      id
      isUndoable
      undoneAt
      undoneBy {
        id
        email
      }
    }
  }
`);
